<template>
    <popper v-if="display" :content="message" offset-distance="2" :hover="true" class="fw-normal text-transform-none">
        <span class="products-product-limit text-danger">
            <span class="icon-info-circled "></span>
        </span>
    </popper>
</template>

<script>

    import mixin_products from "@/mixins/products";

    import Popper from "vue3-popper";

    export default {
        name: "ProductsProductLimit",
        mixins: [mixin_products],
        components: {
            Popper
        },
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        data() {

            return {
                t_path: "components.products.limit",
                state: {
                    display: false,
                    isOrderedProduct: false
                }
            };
        },
        computed: {
            isLoading() {

                return this.$store.getters["user/orders/loading"] || this.$store.getters["user/constraints/loading"];
            },
            isOrderedProduct() {

                return this.isLoading
                    ? this.state.isOrderedProduct
                    : this.products_productOrdered(this.value);
            },
            display() {

                return this.isLoading ? this.state.display : this.products_displayProductLimitMessage(this.value);
            },
            message() {

                if (
                    !this.isOrderedProduct
                    && this.value.allowed_to_order_reason
                    && this.value.allowed_to_order_reason.code
                    && (
                        "string" === typeof this.value.allowed_to_order_reason.code
                        || 0 < this.value.allowed_to_order_reason.code.length
                    )
                    && this.value.allowed_to_order_reason.conflicting_products
                    && 0 < this.value.allowed_to_order_reason.conflicting_products.length
                ) {

                    const errorCode = "string" === typeof this.value.allowed_to_order_reason.code
                        ? this.value.allowed_to_order_reason.code
                        : this.value.allowed_to_order_reason.code[0];

                    const conflictingProducts = this.value.allowed_to_order_reason.conflicting_products.map(
                        product => this.products_translateProductName(
                            product,
                            ["genericName", "generic_name", "name"]
                        )
                    );

                    return this.t(`error.${errorCode}`, conflictingProducts.length, {
                        named: {name: conflictingProducts.join(", ")}
                    });
                }

                if (1 < this.value.product_type.length) {

                    return this.t("type.default_multiple");
                }

                for (let i = 0; i < this.value.product_type.length; i ++) {

                    if (true === this.te(`type.${this.value.product_type[i]}`)) {

                        return this.t(`type.${this.value.product_type[i]}`);
                    }
                }

                return this.t("type.default");
            }
        },
        watch: {
            isLoading: {
                immediate: true,
                handler(newValue) {

                    if (false === newValue) {

                        this.state.display = this.display;
                        this.state.isOrderedProduct = this.isOrderedProduct;
                    }
                }
            }
        }
    }
</script>